export default function (state = null, action) {
    switch (action.type) {
        case "SHOW_EXPERTS":
            return action.payload
            break;
        default:
            return state;
    }
}